import { OsUpdateStatus, OsUpdateStatusOverviewState } from '@era/osupdates-sdk';

import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

export type ExtendedOsUpdateStatusOverviewState = OsUpdateStatusOverviewState;

export interface OSUpdateStatus extends OsUpdateStatus {
  locationId?: string;
  overviewState?: ExtendedOsUpdateStatusOverviewState;
}
export type DeviceOsUpdateStatusState = EntityState<OSUpdateStatus>;
export function selectId(status: OSUpdateStatus) {
  return status.udid;
}
export const adapter: EntityAdapter<OSUpdateStatus> = createEntityAdapter<OSUpdateStatus>({
  selectId,
});
export const initialState: DeviceOsUpdateStatusState = adapter.getInitialState();
